<template>
  <div class="disponibiliteSemaine">
    <div v-for='dispo in getDisposInformation' :key='dispo.id' class='disponibilite'>
      <b-tooltip class="width-100percent"
        :label="dispo.info"
        :delay="1000"
        type="is-primary"
        position="is-left"
        append-to-body>
        <div @click="actionToDo(dispo)"
          class='shape ellipsis is-cursor-pointer'
          :class='[getColorSelected(dispo), {"has-background-white": dispo.stock > 0 }]'
          :style="dispo.styles">
          <div class="content">
            <b-icon v-if="dispo.nePasReafficher" custom-class="height-100" class="mgr-2px"
              type="is-link" icon="minus-circle" size="is-small">
            </b-icon>
            <div v-if="afficherAnnonceur && !isSelected(dispo)"
              class="annonceur">{{ dispo.annonceur }}</div>
            <div>{{ dispo.stock - dispo.vendu }}/{{ dispo.stock }}</div>
          </div>
        </div>
      </b-tooltip>
    </div>
    <b-modal v-model="afficherAffectationInformation"
             has-modal-card
             class="modal">
      <information-option-blocage
          :allAffectationOfProduct="affectationToDisplay"
          :objectif="objectif"
          :nbFaceDispo="nbFacesTotal"
          :stock="stock"
          :libelle="data.libelle"
          :date="dateReseauTempo"
          :semaine="semaine"
          :idProduitReseau="data.id"
          @close="afficherAffectationInformation = false">
      </information-option-blocage>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import messageErreur from '@/services/general/messageErreur';
import { DELETE_LIGNE_IN_PANIER } from '@/store/modules/planningReseauTempo-mutation-type';
import calculateStyleCelluleEtatObtenu from '@/services/planningReseauTempo/calculateStyleCelluleEtatObtenu';
import informationOptionBlocage from '@/components/optionBlocage/informationOptionBlocage';
import getDatesDepartReseauTempo from '@/services/devisCommandes/getDatesDepartReseauTempo';
import formatDate from '@/services/general/formatDate';
import { BLOQUE, OPTION, AUCUN } from '@/configuration/optionBlocage/optionBlocage';
import { PRODUIT_ID_LOCATION_PAR_DEFAUT } from '@/configuration/societe/societe';
import getProduitLocDefaut from '@/services/dcf/produit/getProduitLocDefaut';
import { getAffectationProduitReseauTempo } from '@/api/affectation/index';
import getDateWithAnneeSemaineAndJourDepart
  from '@/services/general/getDateWithAnneeSemaineAndJourDepart';

const produitReseauTempo = createNamespacedHelpers('planningReseauTempo');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'DisponibiliteSemaine',
  data() {
    return {
      error: false,
      messages: [],
      afficherAffectationInformation: false,
      nbFacesTotal: 0,
      stock: 0,
      allAffectationToDisplay: {},
      affectationToDisplay: [],
      dateReseauTempo: null,
      semaine: 0,
      objectif: null,
    };
  },
  components: {
    informationOptionBlocage,
  },
  props: {
    data: Object,
    index: Number,
  },
  methods: {
    ...produitReseauTempo.mapActions({
      actionAddLigneInPanier: 'addLigneInPanier',
    }),
    ...produitReseauTempo.mapMutations({
      deleteProduit: DELETE_LIGNE_IN_PANIER,
    }),
    checkErreur(informationProduit) {
      this.error = false;
      this.messages = [];
      if (!this.briefStocke.produitLocation) {
        this.messages.push(this.$i18n.t('reseauTempo.brief.errors.produitLoc'));
      }
      if (this.briefStocke.produitLocation
        && this.briefStocke.produitLocation.id === PRODUIT_ID_LOCATION_PAR_DEFAUT
        && !informationProduit.produitReseau.produitParDefautId) {
        this.messages.push(this.$i18n.t('reseauTempo.brief.errors.produitDefaultLoc'));
      }
      if (this.messages.length > 0) this.error = true;
    },
    actionToDo(dispo) {
      if (this.isAddRoute || this.boutonBloquer || this.boutonOption || this.boutonSelection) {
        this.ajouterAuPanier(dispo);
        return;
      }
      this.showAffectation(dispo);
    },
    async showAffectation(dispo) {
      this.nbFacesTotal = dispo.stock - dispo.vendu;
      this.stock = dispo.stock;
      this.objectif = dispo.objectif;
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (this.allAffectationToDisplay[dispo.ligneReseau.anneeSemaine] == null) {
          this.allAffectationToDisplay[dispo.ligneReseau.anneeSemaine] = [];
          const listAffectationInformation = [{
            id: dispo.produitId,
            anneeSemaines: [dispo.ligneReseau.anneeSemaine],
          }];
          const affectation = (
            await getAffectationProduitReseauTempo(listAffectationInformation, true, true, true)
          ).data.result;
          if (affectation[dispo.produitId]) {
            this.allAffectationToDisplay[
              dispo.ligneReseau.anneeSemaine] = affectation[dispo.produitId];
          }
          loadingComponent.close();
        }
      } catch (e) {
        if (dispo.allAffectationOfProduct) {
          this.allAffectationToDisplay[
            dispo.ligneReseau.anneeSemaine] = dispo.allAffectationOfProduct;
        }
        throw e;
      } finally {
        loadingComponent.close();
        this.affectationToDisplay = this.allAffectationToDisplay[dispo.ligneReseau.anneeSemaine];
        this.afficherAffectationInformation = true;
        const date = getDatesDepartReseauTempo(dispo.ligneReseau.anneeSemaine,
          dispo.ligneReseau.jourDepart);
        this.dateReseauTempo = {
          dateDebut: formatDate(date.dateDebut),
          dateFin: formatDate(date.dateFin),
          jourDepart: moment(date.dateDebut).format('dddd'),
        };
        const anneeSemaine = dispo.ligneReseau.anneeSemaine.toString();
        this.semaine = anneeSemaine.substr(anneeSemaine.length - 2);
      }
    },
    getColorSelected(dispo) {
      if (!this.isSelected(dispo)) return '';
      const ligneInPanier = this.panier.find((ligne) => {
        return (dispo.produitId === ligne.produitId
          && dispo.ligneReseau.anneeSemaine === ligne.ligneReseau.anneeSemaine);
      });
      if (ligneInPanier.etatSouhaite === BLOQUE) return 'selected selected-bloquer';
      if (ligneInPanier.etatSouhaite === OPTION) return 'selected selected-option';
      return 'selected selected-select';
    },
    isSelected(dispo) {
      if (!this.panier) return true;
      const isAlreadyAdd = this.panier.some((ligne) => {
        return (dispo.produitId === ligne.produitId
        && dispo.ligneReseau.anneeSemaine === ligne.ligneReseau.anneeSemaine);
      });
      return isAlreadyAdd;
    },
    async ajouterAuPanier(dispo) {
      const loadingComponent = this.$buefy.loading.open();
      const indexPanier = this.panier.findIndex((panier) => {
        return (dispo.produitId === panier.produitId
        && dispo.ligneReseau.anneeSemaine === panier.ligneReseau.anneeSemaine);
      });
      if (indexPanier > -1 && this.panier[indexPanier].commandeId) {
        messageErreur(this.$i18n, this.$i18n.t('reseauTempo.brief.errors.errorProduitCommande'));
        loadingComponent.close();
        return;
      }
      if (this.isSelected(dispo)) {
        if ((this.panier[indexPanier].etatSouhaite === BLOQUE && this.boutonBloquer)
        || (this.panier[indexPanier].etatSouhaite === OPTION && this.boutonOption)
        || (this.panier[indexPanier].etatSouhaite === AUCUN
        && (this.boutonSelection))) {
          this.deleteProduit({ index: indexPanier, isFromDCF: false, isFromSelectScreen: true });
        } else if (this.boutonOption) {
          this.panier[indexPanier].etatSouhaite = OPTION;
        } else this.panier[indexPanier].etatSouhaite = this.boutonBloquer ? BLOQUE : AUCUN;
        loadingComponent.close();
        return;
      }
      try {
        this.checkErreur(this.data);
        if (this.error) {
          loadingComponent.close();
          messageErreur(this.$i18n, this.messages.join('\n'));
          return;
        }
        let produitLocation = this.briefStocke.produitLocation;
        if (this.briefStocke.produitLocation
          && this.briefStocke.produitLocation.id === PRODUIT_ID_LOCATION_PAR_DEFAUT) {
          produitLocation = await getProduitLocDefaut(
            this.produitsLocation,
            this.data.supportCommercial.societeId,
            this.data.produitReseau.produitParDefautId,
            this.societeActiveId,
          );
          if (!produitLocation) {
            messageErreur(this.$i18n, this.$i18n.t('reseauTempo.brief.errors.errorProduitLocationNotFound'));
            loadingComponent.close();
            return;
          }
        }
        await this.actionAddLigneInPanier(
          {
            produitReseauId: this.data.id,
            produitLocation: produitLocation,
            date: dispo.date,
            ligneReseau: dispo.ligneReseau,
            isOption: this.boutonOption,
            isBloquer: this.boutonBloquer,
          },
        );
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    getInfoTooltip(dispo) {
      const dateDepart = getDateWithAnneeSemaineAndJourDepart(dispo.anneeSemaine, dispo.jourDepart);
      if (dispo.annonceur) return `${dispo.annonceur} - ${formatDate(dateDepart)}`;
      return `${formatDate(dateDepart)}`;
    },
  },
  computed: {
    ...produitReseauTempo.mapGetters({
      datePlanning: 'datePlanning',
      briefStocke: 'brief',
      panier: 'panier',
      afficherAnnonceur: 'afficherAnnonceur',
      boutonBloquer: 'boutonBloquer',
      boutonOption: 'boutonOption',
      boutonSelection: 'boutonSelection',
      typeDCF: 'typeDCF',
      produitsLocation: 'produitsLocation',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    isAddRoute() {
      return this.$route.name === 'c.bodac.commandes-planningReseauTemporaire';
    },
    getDisposInformation() {
      const dispoIntheDate = this.data.dispo.filter(d => moment(d.date)
        .isBetween(this.datePlanning.dateStart, this.datePlanning.dateEnd, 'day', '[]'));
      return dispoIntheDate.length > 1 ? dispoIntheDate.map(d => {
        const sizeInformationOfWeek = {};
        sizeInformationOfWeek.stock = d.stock;
        sizeInformationOfWeek.vendu = d.vendu;
        sizeInformationOfWeek.objectif = d.objectif;
        sizeInformationOfWeek.annonceur = d.annonceur;
        sizeInformationOfWeek.nePasReafficher = d.nePasReafficher;
        sizeInformationOfWeek.date = {
          dateDebut: moment(d.date).subtract(6, 'd'),
          dateFin: moment(d.date),
        };
        sizeInformationOfWeek.ligneReseau = {
          anneeSemaine: d.anneeSemaine,
          qteFacesPrevues: d.nbFacePrevuStock,
          qteFacesSouhaitees: d.nbFacePrevuStock - d.vendu,
          jourDepart: d.jourDepart,
          lignesCmdSelProduits: [],
        };
        sizeInformationOfWeek.produitId = d.produitId;
        sizeInformationOfWeek.styles = calculateStyleCelluleEtatObtenu(d);
        sizeInformationOfWeek.allAffectationOfProduct = d.allAffectationOfProduct;
        sizeInformationOfWeek.info = this.getInfoTooltip(d);
        return sizeInformationOfWeek;
      }) : [];
    },
  },
};
</script>

<style>
</style>
